module.exports = __webpack_public_path__ + "static/media/5.bf57399a.jpg";